<template>
  <BDXEditFormWrapper
    v-bind="$attrs"
  >
    <ValidationObserver v-slot="{ handleSubmit }" slim>
      <form @submit.prevent="handleSubmit(onSubmit)">
        <ErrorMessages :errors="errors" />

        <b-row class="mb-4 bdx-status-container">
          <b-col lg="4" class="">
            <BDXEditFormBDXStatus
              use-keep-as-is-option
              v-model="formData.bdx_status"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4">
            <BDXEditFormContinuousContract
              :disabled="isMultiIds"
              use-keep-as-is-option
              v-model="formData.continuous_contract"
            />
          <!-- 
          <BDXEditFormFCPStatus
              :disabled="isMultiIds"
              use-keep-as-is-option
              v-model="formData.fcp_status"
            />
          </b-col>
          <b-col
            lg="4"
            v-if="
              !!formData.fcp_status && formData.fcp_status !== KEEP_AS_IS_VALUE
            "
          >
            <BDXEditFormFCPStartDate
              :disabled="isMultiIds"
              v-model="formData.fcp_start_date"
              use-keep-as-is-option
            /> -->
            
          </b-col>
          <b-col lg="4">
            <BaseInput disabled label="Jurisdiction" size="sm">
              <template v-slot:label> Jurisdiction </template>
            </BaseInput>
          </b-col>
        </b-row>

<!--         <b-row>
          <b-col lg="4">
            <BDXEditFormContinuousContract
              :disabled="isMultiIds"
              use-keep-as-is-option
              v-model="formData.continuous_contract"
            />
          </b-col>
        </b-row> -->

        <b-row>
          <b-col>
            <RLSUnderwriterLeadsChecklist
              v-model="formData.underwriter_lead"
              :searchable="false"
              :is-fetching="isFetchingUWRLSGroupItems"
              :rls-group-items="rlsUWGroupItems"
              :auto-fetch-rls-group-items="false"
              use-keep-as-is-option
            />
          </b-col>
          <b-col>
            <RLSUnderwriterFollowersChecklist
              v-model="formData.underwriter_follower"
              :searchable="false"
              :is-fetching="isFetchingUWRLSGroupItems"
              :rls-group-items="rlsUWGroupItems"
              :auto-fetch-rls-group-items="false"
              use-keep-as-is-option
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col v-if="!isCompanyRoleName('TPA')">
            <BDXEditFormTPA
              :disabled="true"
              v-model="formData.tpa"
              use-keep-as-is-option
              @created:tpa="(newItem) => onRLSItemCreated(newItem, 'tpa')"
              @removed:tpa="() => onRLSItemRemoved('tpa')"
            />
          </b-col>
          <b-col v-if="!isCompanyRoleName('Broker')">
            <BDXEditFormBroker
              v-model="formData.broker"
              use-keep-as-is-option
              @created:broker="(newItem) => onRLSItemCreated(newItem, 'broker')"
              @removed:broker="() => onRLSItemRemoved('broker')"
            />
          </b-col>
          <b-col v-if="!isCompanyRoleName('Coverholder')">
            <BDXEditFormCoverholder
              :disabled="true"
              v-model="formData.coverholder"
              use-keep-as-is-option
              @created:coverholder="
                (newItem) => onRLSItemCreated(newItem, 'coverholder')
              "
              @removed:coverholder="() => onRLSItemRemoved('coverholder')"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="4">
            <BDXEditFormCurrency
              :disabled="isMultiIds"
              use-keep-as-is-option
              v-model="formData.currency_type"
            />
          </b-col>
          <b-col lg="4">
            <BDXEditFormYearOfAccount
              v-model="formData.year_of_account"
              name="Year of account"
              class="w-100 mt-auto"
              :disabled="isMultiIds"
              :required="
                !!formData.continuous_contract ||
                formData.continuous_contract !== KEEP_AS_IS_VALUE
              "
              use-keep-as-is-option
            />
          </b-col>
          <b-col lg="4">
            <BaseInput disabled label="UCR" size="sm" />
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <BaseInput disabled label="Account Name" size="sm">
              <template v-slot:label> Account Name </template>
            </BaseInput>
          </b-col>
          <b-col>
            <BaseInput disabled label="Account Code" size="sm" />
          </b-col>
          <b-col>
<!--             <BDXEditFormAccountType
              v-model="formData.account_type"
              use-keep-as-is-option
              :disabled="isMultiIds"
              :required="
                !!formData.fcp_status && formData.fcp_status != KEEP_AS_IS_VALUE
              "
            /> -->
          </b-col>
        </b-row>

        <div class="mt-2">
          <BaseButton
            :loading="isSubmitting"
            :disabled="isSlipShareExeeded || isSubmitting"
            type="submit"
            >Save</BaseButton
          >
        </div>
      </form>
    </ValidationObserver>
  </BDXEditFormWrapper>
</template>

<script>
import Vue from 'vue'
import {
  defineComponent,
  computed,
  ref,
  provide,
  onMounted,
  watch
} from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { createVuexHelpers } from 'vue2-helpers'
import { startsWith } from 'lodash-es'

import { KEEP_AS_IS_VALUE } from '@constants'
import {
  useToast,
  useUserCompany,
  useCurrentUser,
  useRLSGroup
} from '@composables'
import { LincolnGlobalUMRService } from '@services'

import { BaseInput, BaseButton } from '@components/base'
import { ErrorMessages } from '@components/misc'
import {
  RLSUnderwriterLeadsChecklist,
  RLSUnderwriterFollowersChecklist
} from '@components/rls'

import { BDXEditFormInjectionKey } from '../bdx-edit-form/BDXEditForm.constants'
import BDXEditFormWrapper from '../bdx-edit-form/BDXEditFormWrapper.vue'
import BDXEditFormYearOfAccount from '../bdx-edit-form/BDXEditFormYearOfAccount.vue'
import BDXEditFormTPA from '../bdx-edit-form/BDXEditFormTPA.vue'
import BDXEditFormBroker from '../bdx-edit-form/BDXEditFormBroker.vue'
import BDXEditFormCoverholder from '../bdx-edit-form/BDXEditFormCoverholder.vue'
import BDXEditFormFCPStatus from '../bdx-edit-form/BDXEditFormFCPStatus.vue'
import BDXEditFormFCPStartDate from '../bdx-edit-form/BDXEditFormFCPStartDate.vue'
import BDXEditFormCurrency from '../bdx-edit-form/BDXEditFormCurrency.vue'
import BDXEditFormAccountType from '../bdx-edit-form/BDXEditFormAccountType.vue'
import BDXEditFormContinuousContract from '../bdx-edit-form/BDXEditFormContinuousContract.vue'
import BDXEditFormBDXStatus from './BDXEditFormBDXStatus.vue'

export default defineComponent({
  name: 'BDXBulkEditForm',
  components: {
    ValidationObserver,

    BaseInput,
    BaseButton,

    ErrorMessages,

    RLSUnderwriterLeadsChecklist,
    RLSUnderwriterFollowersChecklist,

    BDXEditFormWrapper,
    BDXEditFormYearOfAccount,
    BDXEditFormTPA,
    BDXEditFormBroker,
    BDXEditFormCoverholder,
    BDXEditFormFCPStatus,
    BDXEditFormFCPStartDate,
    BDXEditFormCurrency,
    BDXEditFormAccountType,
    BDXEditFormContinuousContract,
    BDXEditFormBDXStatus
  },
  props: {
    value: Boolean,
    ids: {
      type: Array,
      default: () => []
    },
    isModal: Boolean
  },
  emits: ['success', 'change'],
  setup(props, { emit }) {
    const { useGetters } = createVuexHelpers()

    const { userCompanyRLS } = useGetters(['userCompanyRLS'])

    const {
      isFetching: isFetchingUWRLSGroupItems,
      rlsGroupItems: rlsUWGroupItems,
      fetchRLSGroupItems
    } = useRLSGroup('Underwriter', false)

    const { showToast } = useToast()
    const { isRoleName: isCompanyRoleName } = useUserCompany()
    const { userEmail } = useCurrentUser()

    // Modal
    const showModal = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    const handleHideModal = () => {
      emit('input', false)
    }

    // General
    const isMultiIds = computed(() => 1 < props.ids.length)

    const errors = ref([])
    const hasChanges = ref(false)

    const formData = ref({
      tpa: [],
      broker: [],
      coverholder: [],
      fcp_start_date: '',
      underwriter_lead: [],
      underwriter_follower: [],
      ucr: '',
      continuous_contract: false,
      fcp_status: false,
      fcp_start_date: '',
      currency_type: '',
      account_name: '',
      account_code: '',
      account_type: '',
      year_of_account: '',
      new_tpa: '',
      new_broker: [],
      new_coverholder: [],
      jurisdiction: '',
      bdx_status: false
    })

    // Sums every syndicate line's share across both buckets, same sanity
    // check the backend's own serializer does before it even starts
    // writing - see GlobalUMRUpdateSerializer.validate's identical sum.
    const isSlipShareExeeded = computed(() => {
      const leadUnderwriters = formData.value.underwriter_lead
      const followerUnderwriters = formData.value.underwriter_follower
      const totalPct = [...leadUnderwriters, ...followerUnderwriters].reduce(
        (sum, { syndicates = [] }) => {
          return (
            sum +
            syndicates.reduce((lineSum, { slip_share_pct }) => {
              const pct = parseFloat(slip_share_pct)
              return lineSum + (Number.isFinite(pct) ? pct : 0)
            }, 0)
          )
        },
        0
      )
      return totalPct > 100
    })

    watch(isSlipShareExeeded, (isExceeded) => {
      const label = 'Slip Share Exceeded'
      if (isExceeded) {
        errors.value.push({
          label: label,
          message:
            'Lead Underwriter and Follower Underwriters total slip share exceeds 100%.'
        })
      } else {
        errors.value = errors.value.filter(
          ({ label: errorLabel }) => errorLabel !== label
        )
      }
    })

    const initFormData = async () => {
      formData.value.globalumr_ids = props.ids
      formData.value.underwriter_lead = [{ id: KEEP_AS_IS_VALUE }]
      formData.value.underwriter_follower = [{ id: KEEP_AS_IS_VALUE }]
      formData.value.tpa = [KEEP_AS_IS_VALUE]
      formData.value.broker = [KEEP_AS_IS_VALUE]
      formData.value.coverholder = [KEEP_AS_IS_VALUE]
      //formData.value.ucr = props.ucr
      formData.value.continuous_contract = KEEP_AS_IS_VALUE
      formData.value.fcp_status = KEEP_AS_IS_VALUE
      formData.value.fcp_start_date = ''
      formData.value.currency_type = KEEP_AS_IS_VALUE
      formData.value.year_of_account = KEEP_AS_IS_VALUE
      //formData.value.account_name = props.accountName
      //formData.value.account_code = props.accountCode
      formData.value.account_type = KEEP_AS_IS_VALUE
      //formData.value.jurisdiction = props.jurisdiction || ''
      formData.value.bdx_status = KEEP_AS_IS_VALUE

      const { id: rlsID } = userCompanyRLS.value

      if (isCompanyRoleName('TPA')) {
        //formData.value.tpa = [rlsID]
      } else if (isCompanyRoleName('Broker')) {
        formData.value.broker = props.broker
          .concat([rlsID])
          .filter((item, index, items) => index === items.indexOf(item))
      } else if (isCompanyRoleName('Coverholder')) {
        formData.value.coverholder = props.coverholder
          .concat([rlsID])
          .filter((item, index, items) => index === items.indexOf(item))
      }

      //Init underwriters fetch for both checklist components to share.
      await fetchRLSGroupItems()

      // Initialize watcher after the first update (only watch subsequent updates)
      watch(formData, (_) => (hasChanges.value = true), { deep: true })

      const defineKeepAsIsToggler = (getValue, getDefaultState) => {
        return (newValue, oldValue) => {
          if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
            return newValue
          }
          const hadKeepAsIs = oldValue.find(
            (it) => getValue(it) === KEEP_AS_IS_VALUE
          )
          const hasKeepAsIs = newValue.find(
            (it) => getValue(it) === KEEP_AS_IS_VALUE
          )
          const hasOthers = newValue.some(
            (it) => getValue(it) !== KEEP_AS_IS_VALUE
          )
          if (hasOthers) {
            newValue = newValue.filter((it) => {
              return getValue(it) !== KEEP_AS_IS_VALUE
            })
          }
          if (!hadKeepAsIs && hasKeepAsIs) {
            newValue = getDefaultState()
          }
          return newValue
        }
      }
      const checkListToggler = defineKeepAsIsToggler(
        (it) => it.id,
        () => [{ id: KEEP_AS_IS_VALUE }]
      )
      // Handles followers underwrites 'Keep as is' checkbox toggling
      watch(
        () => formData.value.underwriter_follower,
        (newValue, oldValue) => {
          const finalValue = checkListToggler(newValue, oldValue)
          formData.value.underwriter_follower = finalValue
        }
      )
      // Handles followers tp, broken and coverholder 'Keep as is' multi select toggling toggling
      const multiSelectToggle = defineKeepAsIsToggler(
        (it) => it,
        () => [KEEP_AS_IS_VALUE]
      )
      watch(
        () => formData.value.tpa,
        (newValue, oldValue) => {
          const finalValue = multiSelectToggle(newValue, oldValue)
          formData.value.tpa = finalValue
        }
      )
      watch(
        () => formData.value.broker,
        (newValue, oldValue) => {
          const finalValue = multiSelectToggle(newValue, oldValue)
          formData.value.broker = finalValue
        }
      )
      watch(
        () => formData.value.coverholder,
        (newValue, oldValue) => {
          const finalValue = multiSelectToggle(newValue, oldValue)
          formData.value.coverholder = finalValue
        }
      )
    }

    const filterRLSGroup = (rlsGroup, filterNewItems = true) => {
      return rlsGroup
        .filter((item) => {
          if (!item) return false

          if (filterNewItems) {
            return startsWith(item, 'new:') ? false : true
          } else {
            return startsWith(item, 'new:')
          }
        })
        .map((item) => {
          if (filterNewItems) return item

          const chars = item.split(':')

          return chars[2]
        })
    }

    const buildFormData = (patchData = {}) => {
      const rlsTPAs = filterRLSGroup(formData.value.tpa || [])
      const rlsBrokers = filterRLSGroup(formData.value.broker || [])
      const rlsCoverholders = filterRLSGroup(formData.value.coverholder || [])
      const rlsUnderwriterLeads = (
        formData.value.underwriter_lead || []
      ).filter((item) => !!item)
      const rlsUnderwriterFollowers = (
        formData.value.underwriter_follower || []
      ).filter((item) => !!item)

      const newRLSTPAs = filterRLSGroup(formData.value.tpa || [], false)
      const newRLSBrokers = filterRLSGroup(formData.value.broker || [], false)
      const newRLSCoverholders = filterRLSGroup(
        formData.value.coverholder || [],
        false
      )
      const checkKeepAsIs = (value) => {
        let hasKeepAsIs = false
        if (Array.isArray(value)) {
          hasKeepAsIs = value.find((item) => {
            return (
              (typeof item === 'object' && item.id === KEEP_AS_IS_VALUE) ||
              item === KEEP_AS_IS_VALUE
            )
          })
        } else {
          hasKeepAsIs = value === KEEP_AS_IS_VALUE
        }
        return hasKeepAsIs
      }
      let data = {
        globalumr_ids: formData.value.globalumr_ids,
        rls_tpa: !!rlsTPAs.length ? rlsTPAs : undefined,
        rls_broker: !!rlsBrokers.length ? rlsBrokers : undefined,
        rls_coverholder: !!rlsCoverholders.length ? rlsCoverholders : undefined,
        underwriter_lead: !!rlsUnderwriterLeads.length
          ? rlsUnderwriterLeads
          : undefined,
        underwriter_follower: !!rlsUnderwriterFollowers.length
          ? rlsUnderwriterFollowers
          : undefined,
        fcp_status: formData.value.fcp_status,
        currency_type: formData.value.currency_type,
        //ucr: formData.value.ucr,
        account_type: formData.value.account_type || null,
        //account_name: formData.value.account_name,
        //jurisdiction: formData.value.jurisdiction,
        //account_code: formData.value.account_code,
        year_of_account: formData.value.year_of_account,
        continuous_contract: formData.value.continuous_contract,
        ...(formData.value.fcp_status && {
          ...(formData.value.fcp_start_date && {
            fcp_start_date: formData.value.fcp_start_date
          })
        }),
        ...(!checkKeepAsIs(rlsTPAs) && {
          new_tpa: !!newRLSTPAs.length ? newRLSTPAs[0] : ''
        }),
        ...(!checkKeepAsIs(rlsBrokers) && { new_broker: newRLSBrokers }),
        ...(!checkKeepAsIs(rlsCoverholders) && {
          new_coverholder: newRLSCoverholders
        }),
        user_email: userEmail.value,
        bdx_status: formData.value.bdx_status,
        ...patchData
      }
      //Remove paramaters that have 'Keep AS Is'
      data = Object.entries(data).reduce((data, [key, value]) => {
        if (checkKeepAsIs(value)) {
          return data
        }
        return { ...data, ...{ [key]: value } }
      }, {})
      return data
    }

    // New RLS Item
    const onRLSItemCreated = (newItem, key = 'tpa') => {
      if (!newItem) return

      formData.value[key].push(newItem.id)
    }

    const onRLSItemRemoved = (key = 'tpa') => {
      if ('tpa' === key) {
        formData.value[`new_${key}`] = ''
      } else {
        formData.value[`new_${key}`] = []
      }
    }

    // Form handling
    const isSubmitting = ref(false)

    const onSubmit = async (patchData = {}) => {
      errors.value = []

      isSubmitting.value = true

      try {
        const builtFormData = buildFormData(patchData)

        await LincolnGlobalUMRService.bulkUpdate(builtFormData, {
          transformResponse: [
            (res) =>
              JSON.stringify({
                ...JSON.parse(res),
                noToastError: true
              })
          ]
        })

        isSubmitting.value = false

        hasChanges.value = false

        emit('success')
        emit('input', false)

        Vue.prototype.$emitter.emit('bdx-edit-form:success', {
          status: true
        })

        showToast('Saved successfully.')
      } catch (e) {
        isSubmitting.value = false

        let { data } = e.response || {}
        data = JSON.parse(data) || {}

        if (!!data) {
          if (data.duplicate_globalumr) {
            const duplicateGlobalumrError = data.duplicate_globalumr
            if (
              duplicateGlobalumrError !== undefined &&
              duplicateGlobalumrError.length > 0
            ) {
              Vue.prototype.$swal({
                title: 'Confirmation',
                text: duplicateGlobalumrError[0],
                type: 'warning',
                confirmButtonText: 'Okay',
                preConfirm: async (isConfirmed) => {
                  if (!isConfirmed) return
                  onSubmit({ prompt_merge: true })
                }
              })
            }
          } else {
            const { data: error } = data

            if (!!error) {
              const newErrors = Object.entries(error[0]).map(([key, info]) => {
                const label = key.replace(/_/g, ' ')
                const message = info[0] || 'This field is required'
                return {
                  label,
                  message
                }
              })
              errors.value = newErrors
            }
          }
        }
      }
    }

    onMounted(() => {
      if (props.isModal) return

      initFormData()
    })

    watch(showModal, (newShowModal) => {
      if (newShowModal) {
        initFormData()
      } else {
        hasChanges.value = false
      }
    })

    provide(BDXEditFormInjectionKey, {
      isModal: props.isModal,
      showModal,
      handleHideModal,

      hasChanges
    })

    return {
      KEEP_AS_IS_VALUE,
      isCompanyRoleName,

      isMultiIds,

      errors,

      formData,

      onRLSItemCreated,
      onRLSItemRemoved,

      isSubmitting,
      onSubmit,
      isSlipShareExeeded,
      isFetchingUWRLSGroupItems,
      rlsUWGroupItems
    }
  }
})
</script>

<style scoped>
form {
  display: grid;
  row-gap: 12px;
}

form >>> label,
form >>> .col-form-label {
  line-height: 1.2;
}

form .mx-datepicker {
  margin-top: 7px;
}
form >>> .bdx-status-container {
  position: relative;
}
form >>> .bdx-status-container::after {
  content: '';
  top: 100%;
  left: 15px;
  right: 15px;
  height: 2px;
  background-color: rgb(25, 66, 71);
  display: block;
  position: absolute;
  margin-top: 16px;
}

jurisdiction-select input {
  pointer-events: none;
  background-color: #f5f5f5;
}
</style>
